<div class="santa-relative {{ fullWidth ? 'santa-block' : 'santa-inline-block' }} {{ verticalDirectionConfig[verticalDirection] }}" [class.bordered]="type === 'bordered'">
  <div class="button-container" [ngClass]="buttonSantaBgColor" [class.santa-pr-40]="showArrow" [class.opened]="enabledShadow && state.isOpened" [class.invalid]="invalid" (click)="onOpenClick($event)">
    <ng-container *ngIf="buttonContent as buttonTemplate">
      <ng-container *polymorpheusOutlet="buttonTemplate as primitiveLabel; context: buttonContext | contextToImplicit">
        <span *ngIf="primitiveLabel" class="santa-inline-block santa-py-10 santa-px-20 santa-cursor-pointer">
          {{ primitiveLabel }}
        </span>
      </ng-container>
    </ng-container>

    <img *ngIf="showArrow" [class.icon-opened]="state.isOpened" width="auto" height="auto" loading="eager" [src]="arrowIconLink" class="icon" alt="" />
  </div>

  <div
    *ngIf="initOnStart || state.isOpened"
    class="content-container {{ dropDownDirectionConfig[direction] }}"
    [ngStyle]="{ 'z-index': dropDownZIndex }"
    [ngClass]="{
      'santa-min-w-full santa-w-auto': contentFullWidth,
      'content-hide-divider': hideDivider,
      'santa-invisible': isContentHidden
    }"
    [hidden]="!state.isOpened"
    (click)="onInDropDownClick($event)"
  >
    <ng-container *ngIf="dropDownContent as dropDownTemplate">
      <ng-container *polymorpheusOutlet="dropDownTemplate as primitiveItem; context: dropDownContext | contextToImplicit">
        <div
          *ngIf="primitiveItem"
          class="
            santa-px-20 santa-py-10 santa-whitespace-nowrap santa-truncate santa-cursor-pointer santa-rounded-b-5
            hover:santa-bg-black-100
            active:santa-bg-black-200
          "
        >
          {{ primitiveItem }}
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
